import { DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI } from '../../default-cloud-graph-document-entity-ati';
import { DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI } from '../../default-cloud-graph-remote-link-entity-ati';
import { NounSubtypeKey, TypeFilterValueKey } from '../../filters/universal-type';
import { get3PLogo } from '../../icons';
import { type ThirdPartyConfig } from '../../schemas/3p-config';

import { DocusignIcon } from './icon';
import { DocusignIconBorderless } from './icon-borderless';
import { DocusignSearchResultIcon } from './search-result-icon';

export const docusignConfig: ThirdPartyConfig = {
	displayName: 'Docusign',
	id: 'docusign',
	resourceType: 'docusign-connector',
	icon: get3PLogo(DocusignIcon, 'Docusign', 'medium'),
	iconBorderless: get3PLogo(DocusignIconBorderless, 'Docusign', 'small'),
	searchResultIcon: get3PLogo(DocusignSearchResultIcon, 'Docusign', 'large'),
	integrationAri: 'ari:cloud:platform::integration/docusign',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.Document,
			{
				entities3P: [
					...DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
					...DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI,
				],
				subTypes3P: [NounSubtypeKey.Document],
			},
		],
	]),
	filters: ['lastUpdated', 'onlyTitleMatch'],
	requiresOauth: true,
	isEnabled: () => true,
};
